import CONSTANTS from '@/constants'

export interface JwtPayload {
  sub: string
  exp: number
  data: {
    type: string
    id: number
    attributes: {
      admin: boolean
      must_update_password: boolean
      organization_ids: number[]
      first_name: string
      last_name: string
      email: string
    }
  }
}

export function getAccessTokenPayload(): JwtPayload | null {
  const token = localStorage.getItem(CONSTANTS.ACCESS_TOKEN_STORAGE_KEY)
  if (!token) return null
  return decodeJwtPayload(token)
}

export function decodeJwtPayload(token: string): JwtPayload | null {
  try {
    const payloadSegment = token.split('.')[1]
    if (!payloadSegment) return null

    const base64 = payloadSegment.replace(/-/g, '+').replace(/_/g, '/')
    const padding = '='.repeat((4 - (base64.length % 4)) % 4)
    const bytes = Uint8Array.from(atob(base64 + padding), (c) =>
      c.charCodeAt(0)
    )
    return JSON.parse(new TextDecoder().decode(bytes))
  } catch {
    return null
  }
}
